// extracted by mini-css-extract-plugin
export default {"header":"firewall-manage-link_header__hc6ov","title":"firewall-manage-link_title__IFoA2","section":"firewall-manage-link_section__GCi7N"};